<div *ngIf="isHomePage">
  <h1>{{ banner.title }}</h1>
  <h4>{{ banner.subTitle }}</h4>
</div>

<!-- banner having backgrounnd position with 26% -->
<div *ngIf="isDefaultPageBanner" class="Image one">
  <div
    class="banner-image"
    style="background-image:linear-gradient(rgba(21,47,112,.4),rgba(10,34,95,.18)), url('{{ banner.image }}');  
  background-size: cover; background-position: center 26%;  background-color: #eae9e985;"
  >
    <select *ngIf="(banner.pageVersions || []).length > 0" class="top-right" name="pageVersion" [(ngModel)]="selectedPageVersion" (change)="changePageVersion($event)">
      <option *ngFor="let pageVersion of banner.pageVersions; let i = index" [value]="pageVersion">{{ pageVersion }}</option>
    </select>
    <div class="container">
      <div class="top-left">{{ banner.title }}</div>
      <div class="bottom-left">
        {{ banner.subTitle }}
        <div id="last-updated-info" class="last-updated-info" *ngIf="banner?.lastUpdated?.includes('')">
          <div class="extra-small-font user-name-circle" *ngIf="banner?.editorEmail?.includes('')" [title]="banner.editorEmail || ''">{{ banner.editorShortName || '' }}</div>
          <span class="extra-small-font"> Last Updated: {{ banner.lastUpdated || '' | dateFormat }} </span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- banner having backgrounnd position with 50% -->
<div *ngIf="isAPIDocsBanner" class="Image two">
  <div
    class="banner-image r-notice-banner"
    style="background-image:linear-gradient(rgba(1,9,29,.55),rgba(1,9,29,.55)), url('{{ banner.image }}');  
  background-size: cover; background-position: center 50%;  background-color: #eae9e985;"
  >
    <select *ngIf="(banner.pageVersions || []).length > 0" class="top-right" name="pageVersion" [(ngModel)]="selectedPageVersion" (change)="changePageVersion($event)">
      <option *ngFor="let pageVersion of banner.pageVersions; let i = index" [value]="pageVersion">{{ pageVersion }}</option>
    </select>
    <div id="banner-header" class="container-fluid">
      <div>
        <div id="title" class="shiftdTitleToRight r-notice-title-font-size inline-copy-icon">
          {{ banner.title }}

          <div id="revision-notices-banner" class="small-font copyIcon">
            <a [href]="banner.url || ''" (click)="copyLink(banner.url || '')" title="Open &amp; Copy Link to Clipboard">
              <i class="fa fa-copy"></i>
            </a>
          </div>
        </div>
      </div>
      <div id="subtitle" class="shiftdTitleToRight">
        {{ banner.subTitle }}

        <div id="last-updated-info" class="last-updated-info" *ngIf="banner?.lastUpdated?.includes('')">
          <div class="extra-small-font user-name-circle" *ngIf="banner?.editorEmail?.includes('')" [title]="banner.editorEmail || ''">{{ banner.editorShortName || '' }}</div>
          <span class="extra-small-font"> Last Updated: {{ banner.lastUpdated || '' | dateFormat }} </span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- banner with two men in the banner image 50% -->
<div *ngIf="isCommonBanner" class="Image three">
  <div
    class="banner-image"
    style="background-image:linear-gradient(rgba(1,9,29,.55),rgba(1,9,29,.55)), url('{{ banner.image }}');  
background-size: cover; background-position: center 50%;  background-color: #eae9e985;"
  >
    <select *ngIf="(banner.pageVersions || []).length > 0" class="top-right" name="pageVersion" [(ngModel)]="selectedPageVersion" (change)="changePageVersion($event)">
      <option *ngFor="let pageVersion of banner.pageVersions; let i = index" [value]="pageVersion">{{ pageVersion }}</option>
    </select>
    <div class="container">
      <div class="top-left">{{ banner.title }}</div>
      <div class="bottom-left">
        {{ banner.subTitle }}
        <div id="last-updated-info" class="last-updated-info" *ngIf="banner?.lastUpdated?.includes('')">
          <div class="extra-small-font user-name-circle" *ngIf="banner?.editorEmail?.includes('')" [title]="banner.editorEmail || ''">{{ banner.editorShortName || '' }}</div>
          <span class="extra-small-font"> Last Updated: {{ banner.lastUpdated || '' | dateFormat }} </span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- banner having backgrounnd position with 50% -->
<div *ngIf="isIAGModuleBanner" class="Image four">
  <div
    class="banner-image r-notice-banner"
    style="background-image:linear-gradient(rgba(21,47,112,.4),rgba(10,34,95,.18)), url('{{ banner.image }}');  
  background-size: cover; background-position: center 50%;  background-color: #eae9e985;"
  >
    <select *ngIf="(banner.pageVersions || []).length > 0" class="top-right" name="pageVersion" [(ngModel)]="selectedPageVersion" (change)="changePageVersion($event)">
      <option *ngFor="let pageVersion of banner.pageVersions; let i = index" [value]="pageVersion">{{ pageVersion }}</option>
    </select>
    <div id="banner-header" class="container">
      <div>
        <div id="title" class="r-notice-title-font-size inline-copy-icon">
          {{ banner.title }}

          <div id="revision-notices-banner" class="small-font copyIcon">
            <a [href]="banner.url || ''" (click)="copyLink(banner.url || '')" title="Open &amp; Copy Link to Clipboard">
              <i class="fa fa-copy"></i>
            </a>
          </div>
        </div>
      </div>
      <div id="subtitle">
        {{ banner.subTitle }}

        <div id="last-updated-info" class="last-updated-info" *ngIf="banner?.lastUpdated?.includes('')">
          <div class="extra-small-font user-name-circle" *ngIf="banner?.editorEmail?.includes('')" [title]="banner.editorEmail || ''">{{ banner.editorShortName || '' }}</div>
          <span class="extra-small-font"> Last Updated: {{ banner.lastUpdated || '' | dateFormat }} </span>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isWelcomeUserBanner" class="Image five">
  <div
    class="banner-image"
    style="background-image:linear-gradient(rgba(21,47,112,.4),rgba(10,34,95,.18)), url('{{ banner.image }}');  
  background-size: cover; background-position: center 26%;  background-color: #eae9e985;"
  >
    <select *ngIf="(banner.pageVersions || []).length > 0" class="top-right" name="pageVersion" [(ngModel)]="selectedPageVersion" (change)="changePageVersion($event)">
      <option *ngFor="let pageVersion of banner.pageVersions; let i = index" [value]="pageVersion">{{ pageVersion }}</option>
    </select>
    <div class="container">
      <div class="top-left">{{ banner.title }} {{ userName }}</div>
      <div class="bottom-left">
        {{ banner.subTitle }}
        <div id="last-updated-info" class="last-updated-info" *ngIf="banner?.lastUpdated?.includes('')">
          <div class="extra-small-font user-name-circle" *ngIf="banner?.editorEmail?.includes('')" [title]="banner.editorEmail || ''">{{ banner.editorShortName || '' }}</div>
          <span class="extra-small-font"> Last Updated: {{ banner.lastUpdated || '' | dateFormat }} </span>
        </div>
      </div>
    </div>
  </div>
</div>
